<template>
  <div>
    <ion-menu side="end" type="overlay" content-id="main-content">
      <!--inner header start-->
      <ion-header class="menu-header-container">
        <ion-toolbar class="menu-header-toolbar">
          <ion-buttons slot="start">
            <ion-button fill="clear" class="menu-back-button" @click="goBack">
              <ion-icon
                slot="icon-only"
                :icon="chevronBack"
                class="menu-back-icon"
              ></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-title class="menu-page-title">Account</ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-content>
        <ion-row class="user-info-row">
          <ion-col size="3">
            <ion-avatar class="avatar-menu">
              <img :src="avatar" />
            </ion-avatar>
          </ion-col>
          <ion-col size="7">
            <span class="name-menu">
              {{ fullName || "Guest" }}
            </span>
          </ion-col>
        </ion-row>
        <ion-list>
          <div class="sidemenu" @click="navigateTo('/admin')">
            <ion-row>
              <ion-col size="1">
                <ion-icon class="list-icon" src="assets/icon/lovely-menu.svg" />
              </ion-col>
              <ion-col size="10" class="ion-padding-start">
                <span class="menu-link">Order Management</span>
              </ion-col>
              <ion-col size="1">
                <ion-icon class="list-icon" src="assets/icon/arrow-right.svg" />
              </ion-col>
            </ion-row>
          </div>
          <div class="sidemenu" @click="navigateTo('/admin/order-history')">
            <ion-row>
              <ion-col size="1">
                <ion-icon class="list-icon" src="assets/icon/map-menu.svg" />
              </ion-col>
              <ion-col size="10" class="ion-padding-start">
                <span class="menu-link">Order History</span>
              </ion-col>
              <ion-col size="1">
                <ion-icon class="list-icon" src="assets/icon/arrow-right.svg" />
              </ion-col>
            </ion-row>
          </div>
          <div class="sidemenu" @click="navigateTo('/admin/business-hours')">
            <ion-row>
              <ion-col size="1">
                <ion-icon class="list-icon" src="assets/icon/lovely-menu.svg" />
              </ion-col>
              <ion-col size="10" class="ion-padding-start">
                <span class="menu-link">Business Hours</span>
              </ion-col>
              <ion-col size="1">
                <ion-icon class="list-icon" src="assets/icon/arrow-right.svg" />
              </ion-col>
            </ion-row>
          </div>
          <div class="sidemenu" @click="navigateTo('/admin/menu-review')">
            <ion-row>
              <ion-col size="1">
                <ion-icon class="list-icon" src="assets/icon/map-menu.svg" />
              </ion-col>
              <ion-col size="10" class="ion-padding-start">
                <span class="menu-link">Menu Review</span>
              </ion-col>
              <ion-col size="1">
                <ion-icon class="list-icon" src="assets/icon/arrow-right.svg" />
              </ion-col>
            </ion-row>
          </div>
          <!-- <div class="sidemenu" @click="navigateTo('/admin/print-page')">
            <ion-row>
              <ion-col size="1">
                <ion-icon class="list-icon" src="assets/icon/map-menu.svg" />
              </ion-col>
              <ion-col size="10" class="ion-padding-start">
                <span class="menu-link">Print Test Page</span>
              </ion-col>
              <ion-col size="1">
                <ion-icon class="list-icon" src="assets/icon/arrow-right.svg" />
              </ion-col>
            </ion-row>
          </div> -->
        </ion-list>
      </ion-content>
      <div align="center" class="logout-menu padbot-logout">
        <router-link to="" @click="logout" v-if="fullName">
          Sign Out
        </router-link>
      </div>
    </ion-menu>
    <!--outer header start-->
    <ion-header class="header-container">
      <ion-toolbar class="header-toolbar">
        <ion-searchbar
          v-model="searchValue"
          class="header-search"
          @keypress="handleKeyPress"
          placeholder="Find an order"
        ></ion-searchbar>
      </ion-toolbar>
    </ion-header>
    <!--outer header end -->
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { chevronBack } from "ionicons/icons";
import {
  IonContent,
  IonHeader,
  IonMenuToggle,
  IonButtons,
  IonButton,
  IonList,
  IonIcon,
  IonToolbar,
  IonMenu,
  IonRouterOutlet,
  IonRow,
  IonCol,
  IonSearchbar,
  IonAvatar,
  IonTitle,
  menuController,
} from "@ionic/vue";

export default defineComponent({
  name: "AdminHeaderMenu",
  components: {
    IonContent,
    IonHeader,
    IonMenuToggle,
    IonButtons,
    IonButton,
    IonList,
    IonIcon,
    IonToolbar,
    IonMenu,
    IonRouterOutlet,
    IonRow,
    IonCol,
    IonSearchbar,
    IonAvatar,
    IonTitle,
  },
  setup() {
    return {
      chevronBack,
    };
  },
  data() {
    const storedName = localStorage.getItem("name");
    // Normalize to null if string is "null", empty, or actually null
    const normalizedName =
      !storedName || storedName === "null" ? null : storedName;
    return {
      searchValue: "",
      fullName: normalizedName,
      avatar: process.env.BASE_URL + "assets/placeholders/avatar.png",
    };
  },
  methods: {
    async goBack() {
      console.log("Back button clicked!"); // Debug log
      try {
        // Close the menu overlay first
        await menuController.close("end");
        // Then navigate back
        await this.$router.back();
      } catch (err) {
        console.error("Error closing menu:", err);
      }
    },
    async navigateTo(path) {
      try {
        // Close menu first
        await menuController.close();

        // Check if already on the target path after menu closes
        if (this.$route.path === path) {
          return;
        }

        // Navigate to the path
        await this.$router.push(path);
      } catch (err) {
        // Ignore navigation duplicated errors
        if (err && err.name !== "NavigationDuplicated") {
          console.error("Navigation error:", err);
        }
      }
    },
    handleKeyPress(event) {
      if (event.key === "Enter" && this.searchValue.trim() !== "") {
        // Emit search event to parent component
        this.$emit("search", this.searchValue);
      }
    },
    async logout() {
      // Selectively remove auth-related keys instead of clearing all storage
      // This preserves app preferences, caches, and feature flags
      localStorage.removeItem("token");
      localStorage.removeItem("name");
      localStorage.removeItem("id");
      localStorage.removeItem("cafeId");
      localStorage.removeItem("userType");
      localStorage.removeItem("isLoggedIn");

      // Use Vue Router for SPA navigation
      await this.$router.replace("/userlogin");
    },
  },
});
</script>
<style scoped>
/* Header Container */
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 64px;
}

/* Search Bar */
.header-search {
  --background: #ffffff;
  --color: #1b1b1b;
  --placeholder-color: #828282;
  --icon-color: #1b1b1b;
  --clear-button-color: #828282;
  --border-radius: 8px;
  --box-shadow: none;
  --cancel-button-color: transparent;
  font-family: "Gilroy", sans-serif;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  margin: 0;
}

/* Menu Styles */
ion-menu {
  --width: 100%;
}
.sidemenu {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  color: #1b1b1b;
  font-size: 14px;
  padding-top: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f3f3f3;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
  position: relative;
  user-select: none;
}
.sidemenu:active {
  background-color: #f9f9f9;
}
.sidemenu a,
.sidemenu .menu-link {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  color: #1b1b1b;
  font-size: 14px;
  text-decoration: none;
  width: 100%;
  display: inline-block;
  position: relative;
  z-index: 10;
  pointer-events: auto;
  cursor: pointer;
}
/* Menu Header Styling */
.menu-header-container {
  --background: #f87e63;
}

.menu-header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 64px;
}

.menu-page-title {
  --color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}

.menu-back-button {
  --padding-start: 8px;
  --padding-end: 8px;
  margin: 0;
  min-width: 44px;
  min-height: 44px;
  pointer-events: auto;
  cursor: pointer;
  position: relative;
  z-index: 10;
}

.menu-back-icon {
  color: #ffffff;
  font-size: 24px;
}

.user-info-row {
  padding: 20px 0;
  border-bottom: 1px solid #f3f3f3;
}

.name-menu {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  color: #1b1b1b;
  display: block;
  margin-top: 20px;
}

.avatar-menu {
  margin-left: 10%;
}

.logout-menu {
  position: relative;
  z-index: 10;
}
.logout-menu a {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #f87e63;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  padding: 10px 20px;
  position: relative;
  z-index: 10;
  pointer-events: auto;
}

.padbot-logout {
  padding-bottom: 32px;
}

.list-icon {
  width: 14px;
}

/* Responsive adjustments for tablets */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .toolbar-content {
    padding: 20px;
  }

  .header-search {
    height: 56px;
    font-size: 16px;
  }
}
</style>
